import { UsagePeriod } from "../../graphql/types/user-usage";

export const USAGE_PERIOD_LABELS = {
  [UsagePeriod.DAILY]: "Daily",
  [UsagePeriod.WEEKLY]: "Weekly",
  [UsagePeriod.MONTHLY]: "Monthly",
};
